/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Explorer_Display_Delete_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to delete records: {error}" |
*
* @param {Explorer_Display_Delete_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_delete_failed_toast = /** @type {((inputs: Explorer_Display_Delete_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Delete_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de suppression des enregistrements : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Löschen der Datensätze: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile eliminare i record: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось удалить записи: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudieron eliminar los registros: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`删除记录失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`レコードの削除に失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`रिकॉर्ड हटाने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao excluir registros: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to delete records: ${i?.error}`)
});